// @flow
import { useContext } from 'react';
import StatusCodeContext from '../../server/StatusCodeContext';

type Props = {
  url: string,
  status?: number
};

// Provides a way to issue a server side redirect from within our component tree
const SSRedirect = ({ url, status = 302 }: Props) => {
  const { setStatusCode } = useContext(StatusCodeContext);

  const httpStatus = {
    status,
    url
  };

  setStatusCode(httpStatus);

  return null;
};

export default SSRedirect;
